import React, { MouseEventHandler, useMemo } from 'react'
import { Table_Info, Styled_Table, Styled_Table_Wrapper } from '../styles/table'
import { Button_Main, Button_Notice } from './Button'

interface TableHeader {
  value: string
  label: string
}
interface TableData extends Record<string, any> {}
interface Props {
  headers: TableHeader[]
  data: TableData[]
  rowKey: string
  onClick?: (value:string) => void
  modalKey: string
  isLoading?: boolean
  isError?: boolean
  rowBtn?: string
}

const Table = ({ headers, data, rowKey, isLoading, isError, rowBtn, modalKey, onClick=()=>{} }: Props) => {
  const loadingData = useMemo(() => {
    return [...new Array(20)].map(()=>({}))
  }, [headers])

  const getRowBtn = (rowBtn:string|undefined,rowKey:string) => (rowBtn !== undefined ? rowBtn : rowKey)

  if(isError) return <>에러</>
  return (
    <Styled_Table_Wrapper>
      <Styled_Table>
        <thead>
          <tr>
            {headers.map(({ value, label }) => (
              <th style={{width: value === 'lastUploadedDate' ? '200px' : ''}} key={value}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? 
            loadingData.map((_,index)=>(
              <tr key={index} className={"Loading"}>
              {headers.map((h) => (
                <td key={h.value} >
                  {h.label}
                </td>
              ))}
            </tr>
            ))
          : data?.map((item,index) => (
            <tr key={`${item[rowKey]}@${index}`} >
              {headers.map((h) => (
                <td key={h.value} onClick={getRowBtn(rowBtn,rowKey) === h.value ? ()=>onClick(item[modalKey as keyof typeof item]) : undefined} className={getRowBtn(rowBtn,rowKey) === h.value ? "clickable" : ""}>
                  {h.value !== 'push' ? item[h.value] 
                                      : <Button_Notice mobileId={item.mobileId} />}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Styled_Table>
    </Styled_Table_Wrapper>
  )
}

export default Table
